module.exports = __webpack_public_path__ + "static/media/as_hot.493b4743.png";